import PropTypes from 'prop-types';

import Pagination from '@mui/material/Pagination';

const PaginationComponent = ({
  currentPage,
  totalPages,
  onChange,
  isMobileScreen,
}) => (
  <Pagination
    siblingCount={isMobileScreen ? 0 : 1}
    boundaryCount={isMobileScreen ? 0 : 1}
    count={totalPages}
    page={currentPage}
    color="primary"
    onChange={onChange}
  />
);

PaginationComponent.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  isMobileScreen: PropTypes.bool.isRequired,
};

export default PaginationComponent;
